import { render } from "./DoctorImageSection.vue?vue&type=template&id=38a71b3b&scoped=true"
import script from "./DoctorImageSection.vue?vue&type=script&lang=js"
export * from "./DoctorImageSection.vue?vue&type=script&lang=js"

import "./DoctorImageSection.vue?vue&type=style&index=0&id=38a71b3b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a71b3b"]])

export default __exports__